
import Vue from 'vue';
import EditEventForm from "./EditEventForm.vue";
import ViewEventMenu from "./ViewEventMenu.vue";
import SchedulerService from "../services/scheduler.service";
import schedulerService from "../services/scheduler.service";
import PartyService from "../services/party.service";
import SchedulerEvent from "@/models/schedulerEvent";
import Party from "@/models/party";
import {eventBus} from "@/services/event-bus";
import {VBtn} from "vuetify/lib";
// import RemovePlanForm from "@/components/RemovePlanForm.vue";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";

export default Vue.extend({
  props: {
    userType: {type: String, required: true},
    userId: {type: String, required: true},
  },
  components: {
    editEventForm: EditEventForm,
    viewEventMenu: ViewEventMenu,
    CalendarBtn: VBtn,
    // removePlanForm: RemovePlanForm
  },
  data: () => ({
    isMounted: false,
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'week',
    typeToLabel: [
      'month',
      'week',
      'day'
    ],
    event: new SchedulerEvent({}),
    currentlyEditing: -1,
    selectedEvent: new SchedulerEvent({}),
    value: null,
    selectedElement: null,
    selectedOpen: false,
    events: [] as SchedulerEvent[],
    dialog: false,
    editing: false,
    dialogDate: false,
    party: {} as any,
    user: {} as any,
    intervals: {first: 16, minutes: 30, count: 27, height: 20},
    removePlanDialog: false,
    removePlanDate: new Date().toISOString().substr(0, 10),
    dragEvent: null as any,
    eventOriginalDate: '',
    eventOriginalTime: '',
    dragTime: null as any,
    dragStart: null as any,
    lastEvent: '',
    createEvent: null as any,
    createStart: null as any,
    extendOriginal: null as any,

  }),
  mounted() {
    this.user = JSON.parse(String(localStorage.getItem('user')));
    this.getEvents();
    this.getParty();
    this.isMounted = true;
  },
  computed: {
    nowY() {
      const cal = this.$refs.calendar || {} as any;
      if (!cal && !this.isMounted) {
        return -1;
      }

      return cal.timeToY(cal.times.now) + 'px';
    },
    nowTime() {
      const cal = this.$refs.calendar || {} as any;
      if (!cal && !this.isMounted) {
        return -1;
      }

      return cal.formatTime(cal.times.now);
    },
    calendarInstance(): Vue & {
      prev: () => void;
      next: () => void,
      scrollToTime: (time: number) => boolean,
      $el: HTMLElement
    } {
      return this.$refs.calendar as Vue & {
        prev: () => void,
        next: () => void,
        scrollToTime: (time: number) => boolean,
        $el: HTMLElement
      };
    },
    userIdInt: {
      get(): number {
        return Number(this.userId)
      }
    },
  },
  methods: {
    eventMove(e: any) {
      // console.log('eventMove', e);
    },
    startDrag(e: any) {
      if (e.event && e.timed) {
        this.dragEvent = e.event;
        this.eventOriginalDate = this.dragEvent.dateFrom;
        this.eventOriginalTime = this.dragEvent.timeFrom;
        this.dragTime = null;
        this.extendOriginal = null;
      }

      this.lastEvent = 'startDrag';
    },
    mouseMoveEvent(e: any) {
      console.log('mouseMoveEvent', e);
    },
    toDate(tms: any) {
      return typeof tms === 'string'
          ? new Date(tms)
          : new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute);
    },
    toTimestamp(date: Date) {
      const offset = new Date().getTimezoneOffset()

      return new Date(date.getTime() - (offset * 60 * 1000)).toISOString()
          .replace("T", " ")
          .replace(":00.000Z", "");
    },
    mouseMove(e: any) {
      if (this.dragEvent && this.dragTime !== null) {
        const mouse = this.toDate(e);

        const newStartTime = mouse.getTime() - this.dragTime;
        const newStart = new Date(new Date(this.roundTime(newStartTime)).getTime());

        this.dragEvent.start = this.toTimestamp(newStart);
      } else if (this.createEvent && this.createStart !== null) {
        const mouse = this.toDate(e).getTime();
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = this.toTimestamp(new Date(min));
        this.createEvent.end = this.toTimestamp(new Date(max));
      }
    },
    endDrag(e: any) {
      if (this.dragEvent.dateFrom === this.eventOriginalDate &&
          this.dragEvent.timeFrom === this.eventOriginalTime) {
        this.editEvent(this.dragEvent);
        this.doEndDrag()
      } else {
        schedulerService.updateEvent(this.dragEvent).then(() => this.doEndDrag())
      }
    },
    doEndDrag() {
      this.dragTime = null;
      this.eventOriginalDate = '';
      this.eventOriginalTime = '';
      this.dragEvent = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;

      this.lastEvent = 'endDrag';
    },
    cancelDrag(e: any) {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;

      this.lastEvent = 'cancelDrag';
    },
    roundTime(time: any, down = true) {
      const roundDownTime = 5 * 60 * 1000; // 15 minutes

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime));
    },
    startTime(e: any) {
      const mouse = this.toDate(e);

      if (this.dragEvent && this.dragTime === null) {
        const start = this.toDate(this.dragEvent.start);

        this.dragTime = mouse.getTime() - start.getTime();

      } else {
        // this.createStart = this.roundTime(mouse.getTime());
        // this.createEvent = {
        //   name: '(no title)',
        //   start: this.toTimestamp(new Date(this.createStart)),
        //   end: this.toTimestamp(new Date(this.createStart)),
        // };
        // this.events.push(this.createEvent);
        this.setDialogTime(e);
      }
      this.lastEvent = 'startTime';
    },
    title() {
      return 'calendar'
    },
    isBackoffice() {
      return this.user && this.user.party ? this.user.party.type === 'backoffice' : false;
    },
    prev(): void {
      this.calendarInstance.prev();
    },

    next(): void {
      this.calendarInstance.next();
    },
    async getEvents() {
      if (this.userType == 'therapist') {
        SchedulerService.eventsForTherapist(this.userIdInt).then(events => this.events = events).catch(reason => eventBus.$emit('error', reason));
      } else {
        SchedulerService.eventsForPatient(this.userIdInt).then(events => this.events = events).catch(reason => eventBus.$emit('error', reason));
      }
    },
    async getParty() {
      if (this.userType == 'therapist') {
        PartyService.therapistById(this.userIdInt).then(p => this.party = p).catch(reason => eventBus.$emit('error', reason));
      } else if (this.userType == 'patient') {
        PartyService.patientById(this.userIdInt).then(p => this.party = p).catch(reason => eventBus.$emit('error', reason));
      } else {
        alert(`Niepoprawny typ : ${this.userType}`)
      }
    },
    setDialogDate({date}: any) {
      if (this.isBackoffice()) {
        this.event = new SchedulerEvent({});
        this.dialogDate = true;
        this.event.dateFrom = date;
      }
    },
    setDialogTime({date, time}: any) {
      if (this.isBackoffice()) {
        this.event = new SchedulerEvent({});
        this.dialogDate = true;
        this.event.dateFrom = date;
        this.event.timeFrom = this.calculateTime(time);
      }
    },
    getEventColor(event: SchedulerEvent) {
      if (event.status === 'CONFIRMED') {
        return event.activity.code
      }
      if (event.status === 'CANCELLED_PAID') {
        return 'red'
      }
      if (event.status === 'CANCELLED_FREE') {
        return 'green'
      }
    },
    viewDay({date}: any) {
      this.focus = date;
      this.type = 'day'
    },
    setToday() {
      this.focus = this.today
    },
    onUpdated: function (result: Boolean, ev: SchedulerEvent) {
      if (result) {
        if (!this.editing) {
          this.events.push(ev)
        }
        this.event = new SchedulerEvent({});
        this.hideEventForm();
        this.dialogDate = false;
      }
    }, setParty: function (ev: SchedulerEvent) {
      // eslint-disable-next-line no-console
      console.log(ev);
      if (this.userType == 'therapist') {
        ev.therapist = this.party;
      }
      if (this.userType == 'patient') {
        ev.patient = this.party;
      }
    }, async addEvent(ev: SchedulerEvent) {
      this.setParty(ev);
      await this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          SchedulerService.addEvent(ev).then(result => {
            this.onUpdated(result, ev);
          }).catch(reason => eventBus.$emit('error', reason));
        } else {
          // eslint-disable-next-line no-console
          console.log("validation error");
        }
      });
    },
    async updateEvent(ev: SchedulerEvent) {
      this.setParty(ev);
      await this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          SchedulerService.updateEvent(ev).then(result => {
            this.onUpdated(result, ev);
          }).catch(reason => eventBus.$emit('error', reason));
        } else {
          // eslint-disable-next-line no-console
          console.log("validation error");
        }
      });
    },
    editEvent(ev: any) {
      this.event = ev;
      this.dialog = true;
      this.editing = true;
    },
    async deleteEvent(ev: number) {
      SchedulerService.removeEvent(ev).then(() => this.removeFromEvents(ev)).catch(reason => eventBus.$emit('error', reason));
    },
    removeFromEvents(ev: number) {
      const idx = this.events.findIndex(el => el.id == ev);
      if (idx > -1) {
        this.events.splice(idx, 1);
      }
      this.selectedOpen = false;
    },
    showEvent({nativeEvent, event}: any) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => this.selectedOpen = true, 10)
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    updateRange({dateFrom, timeFrom}: any) {
      this.event.dateFrom = dateFrom;
      this.event.timeFrom = timeFrom;
      this.event.duration = 60
    },
    eventNameProperty(e: any) {
      return e.input.timeFrom + ' - ' + (this.userType === 'therapist' ? this.getPartyNameAndSurname(e.input.patient as Party) :
          `${e.input.activity.name} - ${e.input.therapist.surname}<br />${e.input.paymentStatus}`)
    },
    eventDetails(e: SchedulerEvent) {
      return e.paymentStatus === 'PAID';
    },
    getPartyNameAndSurname(p: Party): String {
      return `${p.name} ${p.surname}`
    },
    calculateTime(t: string): string {
      const hourAndMinArr = t.split(":");
      const minutes = Number(hourAndMinArr[1]);
      return `${hourAndMinArr[0]}:${minutes > 30 ? '30' : '00'}`;
    },
    hideEventForm() {
      this.dialog = false;
      this.editing = false;
      this.dialogDate = false;
    },
    hideRemovePlanForm() {
      SchedulerService.removePlan(this.userIdInt, this.userType, this.removePlanDate)
          .catch(e => eventBus.$emit('error', e.message))
          .then(() => this.removePlanDialog = false)
          .then(() => this.getEvents());
    },
    printPdf() {
      // const canvasElement = document.createElement('canvas');
      const el = document.getElementById("toPrint")!;
      const doc = new jsPDF('p', 'px', 'a4');
      const docW = doc.internal.pageSize.getWidth();
      const docH = doc.internal.pageSize.getHeight();
      // eslint-disable-next-line no-console
      console.log(el);
      html2canvas(el, {
        scale: 3,
      }).then(function (canvas) {
        const img = canvas.toDataURL("image/jpeg", 0.8);
        doc.addImage(img, 'JPEG', 10, 10, docW - 20, docH - 20);
        doc.save("calendar.pdf");
      })
    },
  },
  errorCaptured(err: Error): boolean | void {
    eventBus.$emit('error', err.message);
  }
});
